
import { Component } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FiltroModule } from "../../_tools/filtro.module";
import { NotasTablaComponent } from "../notas-tabla/notas-tabla.component";
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-notas-shell',
  templateUrl: './notas-shell.component.html',
  styleUrls: ['./notas-shell.component.scss'],
  standalone: true,
  imports: [
    MatSidenavModule,
    MatBadgeModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    FiltroModule,
    NotasTablaComponent,
    MatProgressBarModule,
],
  
})
export class NotasShellComponent {

}
